

// Lazy-loaded components for code splitting
const DocumentList = () => import(/* webpackChunkName: "document" */ "./pages/ListPage.vue");
const DocumentDetail = () => import(/* webpackChunkName: "document" */ "./pages/FormPage.vue");
const DocumentView = () => import(/* webpackChunkName: "document" */ "./pages/ViewPage.vue");
const DocumentIndex = () => import(/* webpackChunkName: "document" */ "./pages/IndexPage.vue");
export default [
  {
    path: "/document",
    component: DocumentIndex,
    redirect: "/document/list",
    name: "document",
    children: [
      {
        path: "list",
        component: DocumentList,
        name: "document.list",
      },
      {
        path: "create",
        component: DocumentDetail,
        name: "document.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: DocumentDetail,
        name: "document.edit",
        props: { create: false },
      },
      {
        path: "view/:id",
        component: DocumentView,
        name: "document.view",
        props: { create: false },
      },
    ],
  },
];
